import React from "react";
import { Check } from "lucide-react";
import { COLOR_KEYS, getColor } from "../../lib/categoryColors";
import { cn } from "../../lib/utils";

/**
 * Eight named-token color picker. Renders one circular swatch per palette key
 * with a check on the active selection. Used in AdminCategories alongside
 * <HexColorPicker /> so admins can pick from the curated set OR any custom hex.
 */
export function ColorSwatchPicker({ value, onChange }) {
  return (
    <div className="flex flex-wrap gap-2" data-testid="color-swatch-picker">
      {COLOR_KEYS.map((key) => {
        const c = getColor(key);
        const active = value === key;
        return (
          <button
            type="button"
            key={key}
            onClick={() => onChange(key)}
            className={cn(
              "h-8 w-8 rounded-full transition-all flex items-center justify-center ring-offset-2 ring-offset-white",
              c.swatch,
              active ? "ring-2 ring-slate-900 scale-110" : "ring-1 ring-slate-200 hover:scale-105"
            )}
            aria-label={`Color ${key}`}
            data-testid={`color-swatch-${key}`}
          >
            {active && <Check className="h-3.5 w-3.5 text-white" strokeWidth={3} />}
          </button>
        );
      })}
    </div>
  );
}
